import React, {useRef, useEffect, useState} from 'react';

class AudienceVector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            prompt: '',
            loading: false,
            result: null,
            beautyResult: '',
            beautyResultLines: 0,
            model: "text-embedding-ada-002",
            models: [
                {"text": "text-embedding-ada-002", "id": "text-embedding-ada-002"},
                {"text": "text-embedding-3-large", "id": "text-embedding-3-large"},
                {"text": "text-embedding-3-small", "id": "text-embedding-3-small"},
            ],
        };


        this.doPrompt = this.doPrompt.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePromptChange = this.handlePromptChange.bind(this);
        this.exportResultAsCsv = this.exportResultAsCsv.bind(this);
        this.onModelChangeHandler = this.onModelChangeHandler.bind(this);
    }

    getClient() {
        return this.clients[this.state.vector]
    }

    handlePromptChange(event) {
        this.setState({'prompt': event.target.value})
    }

    onModelChangeHandler(event) {
        this.setState({ 'model': event.target.value });

    }

    handlebeautyResult(event) {
        return false;
    }

    setLoading(state) {
        this.setState({'loading': state})
    }

    getResultAsArray() {
        let data = []
        this.state.result.response.embeddings.forEach((entry) => {
            data.push(entry.embedding)
        });

        return data;
    }

    setPromptResult(response) {
        this.setLoading(false);

        this.setState({ 'result': response });

        // let beautyResult = ""
        // let rawData = this.getResultAsArray()
        // rawData.forEach((row) => {
        //     beautyResult += row.join("\t").replaceAll(".", ",") + "\n";
        // });

        // this.setState({ 'beautyResult': beautyResult });

        // const textAreaSize = rawData.length > 10 ? 10 : rawData.length + 1;
        // this.setState({ 'beautyResultLines': textAreaSize });
    }

    exportResultAsCsv(response) {
        let data = this.getResultAsArray()

        const csvData = new Blob([this.convertToCSV(data)], { type: 'text/csv' });
        const csvURL = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = csvURL;
        link.download = `audience-vector.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    convertToCSV(objArray) {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
    
        for (let i = 0; i < array.length; i++) {
          let line = '';
          for (let index in array[i]) {
            if (line !== '') line += ';';
    
            line += array[i][index];
          }
          str += line + '\r\n';
        }
        return str.replaceAll(".", ",");
      };

    clearSearchResult(response) {
        this.setState({
            'result': []
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.doPrompt();
    }

    doPrompt() {
        this.setLoading(true);
        
        const params = { "prompt": this.state.prompt, "model": this.state.model };

        const requestOptions = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(params) };
        
        // fetch('http://10.2.0.102:30150/vector/', requestOptions)
        // fetch('http://0.0.0.0:9090/vector/', requestOptions)
        fetch('https://llm-evaluation-api.comsulting.net/vector/', requestOptions)
            .then(response => response.json())
            .then(this.setPromptResult.bind(this))
            .catch((error) => {
                this.setLoading(false);
                console.error('Error:', error);
                alert("Es ist ein Fehler aufgetreten. In der Konsole finden Sie weitere Informationen. Bitte die Suche erneut starten.")
            });
    }

    render() {
        return (
            <div class="container">
                <h1 class="mt-3">Pythia - Audience Vector</h1>

                <div class="main-form">
                    <form onSubmit={this.handleSubmit} className="mb-3">
                        <div class="row">
                            <div class="col">
                                <label>Prompt (Max: 5.000 Zeilen)</label>
                                <textarea type="text" class="form-control" value={this.state.prompt} onChange={this.handlePromptChange} rows="8"/>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-6">
                                <select class="form-select" onChange={this.onModelChangeHandler}>
                                    {this.state.models.map((option, index) => {
                                        return <option key={option.id} value={option.id}>
                                            {option.text}
                                        </option>
                                    })}
                                </select>
                            </div>
                            <div class="col-6">
                                <a href="https://platform.openai.com/docs/guides/embeddings#embedding-models" target='_blank'>Model description</a>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col d-grid">
                                <button class="btn btn-outline-primary" onClick={this.doSearch}  type="submit">Submit!</button>
                            </div>
                        </div>


                        <hr/>
                    </form>

                    { this.state.loading == false && this.state.result != null && (

                        <div class="row">
                            <div class="col">
                                {/* <label>Beauty Result</label> */}
                                {/* <textarea type="text" class="form-control" value={this.state.beautyResult}  rows={this.state.beautyResultLines} wrap="off" /> */}
                                <button class="btn btn-outline-primary" onClick={this.exportResultAsCsv}  type="submit">CSV</button>
                                <label>Ready - Rows {this.state.result.response.embeddings.length}</label>
                            </div>
                        </div>
                    )}

                    { this.state.loading == true && (
                        <div class="row">
                            <div class="col result">
                                Loading....
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default AudienceVector;
